// React
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'

// Libraries
import { ThemeProvider, StyleSheetManager } from 'styled-components'

// Components
import BThemed from '../blocks/Themed'

// Shared
import theme from 'ui/themes/public'
import getBrandingColor from 'shared/utils/getBrandingColor'
import { shouldForwardProp } from 'shared/utils/shouldForwardProp'

class Themed extends Component {
  static displayName = 'Themed'

  static propTypes = {
    children: PropTypes.node,
    brandingColor: PropTypes.string
  }

  render () {
    const { children, brandingColor } = this.props

    return (
      <ThemeProvider theme={theme(brandingColor)}>
        <StyleSheetManager shouldForwardProp={shouldForwardProp} enableVendorPrefixes>
          <BThemed>
            {children}
          </BThemed>
        </StyleSheetManager>
      </ThemeProvider>
    )
  }
}

const mapStateToProps = (state, props) => {
  return {
    brandingColor: getBrandingColor()
  }
}

export default reduxConnect(mapStateToProps)(Themed)
